export default {
	state: {
		cliente: {},
		loading: false
	},
	getters: {
		cliente(state){return state.cliente},
		loading(state){return state.loading},
	},
	mutations: {
		setCliente(state, payload){state.cliente = payload},
		showLoading(state){state.loading = true},
		hideLoading(state){state.loading = false},
	},
	actions: {
		getCliente(context, cliente){
			return new Promise((resolve, reject) => {
				context.commit('showLoading')
                axios.get(`api/clientes/${cliente}`)
                    .then(response => {
                        context.commit("setCliente", response.data)
                        resolve(response)
                    })
                    .catch((error) =>{
                        reject(error)
                    }).then(() => {
                        context.commit('hideLoading')
                    })
            })
		},

		setCliente(context, cliente){
			context.commit("setCliente", cliente)
		}
	}

}